import { render } from "./IconComponent.vue?vue&type=template&id=7537a489&scoped=true"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"

import "./IconComponent.vue?vue&type=style&index=0&id=7537a489&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7537a489"]])

export default __exports__